import { FC, PropsWithChildren, useMemo } from 'react';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { SelectionContext, SelectionStore } from './useSelectionProvider';


export const SelectionProvider: FC<PropsWithChildren> = ({ children }) => {
  const store = useMemo(
    () =>
      create(
        immer<SelectionStore>(set => ({
          items: {},
          selected: new Set(),

          addToSelection: id =>
            set(state => {
              state.selected.add(id);
            }),
          removeFromSelection: id =>
            set(state => {
              state.selected.delete(id);
            }),
          clearSelection: () =>
            set(state => {
              state.selected.clear();
            })
        }))
      ),
    []
  );

  return <SelectionContext.Provider value={store}>{children}</SelectionContext.Provider>;
};

export const SelectionManager: FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      <div className="w-full absolute bottom-0 left-0 right-0 bg-white">sadsadasd</div>
      {children}
    </>
  );
};
